<script lang="ts">
    import type { Snippet } from 'svelte';
    import type { ImageAspectRatio } from '@tile/components/product-image/types.ts';

    interface Props {
        size?: { width: string; height: string };
        aspectRatio?: ImageAspectRatio;
        children?: Snippet;
    }

    let { size, aspectRatio, children }: Props = $props();

    const imagePaddingTop = $derived.by(() => {
        if (!aspectRatio) return '100%';

        switch (aspectRatio) {
            case 'landscape':
            case 'landscape-two-column':
                return '69.5%';
            case 'portrait':
                return '143%';
            default:
                return '100%';
        }
    });
</script>

<div
    class="reptile-product-image"
    style:width={size?.width}
    style:height={size?.height}
    style:padding-top={imagePaddingTop}
>
    {@render children?.()}
</div>

<style lang="scss">
    .reptile-product-image {
        position: relative;
    }
</style>
